import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  sendEmail: {
    data: null,
    loading: false,
    error: null,
  },
  jobs: {
    data: [],
    loading: false,
    error: null,
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 0,
  },
};

const emailSlice = createSlice({
  name: 'email',
  initialState,
  reducers: {
    sendEmailStart: (state) => {
      state.sendEmail.loading = true;
      state.sendEmail.error = null;
    },
    sendEmailSuccess: (state, action) => {
      state.sendEmail.loading = false;
      state.sendEmail.data = action.payload;
    },
    sendEmailFail: (state, action) => {
      state.sendEmail.loading = false;
      state.sendEmail.error = action.payload;
    },
    fetchJobsStart: (state) => {
      state.jobs.loading = true;
      state.jobs.error = null;
    },
    fetchJobsSuccess: (state, action) => {
      state.jobs.loading = false;
      state.jobs = {
        ...state.jobs,
        ...action.payload,
      };
    },
    fetchJobsFail: (state, action) => {
      state.jobs.loading = false;
      state.jobs.error = action.payload;
    },
  },
});

export const {
  sendEmailStart,
  sendEmailSuccess,
  sendEmailFail,
  fetchJobsStart,
  fetchJobsSuccess,
  fetchJobsFail,
} = emailSlice.actions;

export default emailSlice.reducer;

